import {message} from "antd/lib/index";

export function getSubStringWithDot(maxLength, ostring) {
    if (ostring.length > maxLength) {
        var subStr1 = ostring.substr(0,maxLength / 2 - 2);
        var subStr2 = ostring.substr(ostring.length-maxLength / 2,maxLength / 2 + 1);
        var subStr = subStr1 + "..." + subStr2 ;
        return subStr;
    } else {
        return ostring;
    }
}

export function showErrorMsg(data) {
    if (data.code === 400) {
        message.error(data.data.info);
    } else {
        message.error(data.message);
    }
}